import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Errors, LocalService, SellerService, ManagerService, StoreService, UserService } from '../../../core';
import { Router, ActivatedRoute } from '@angular/router';
import { PopupMessageService } from '../../../shared/message/services/message.service';
import { CONSTANTS } from '../../../config';

@Component({
  selector: 'app-redeem-points',
  templateUrl: './redeem-points.component.html',
  styleUrls: ['./redeem-points.component.scss']
})
export class RedeemPointsComponent implements OnInit, AfterViewInit {

  errors: Errors = { errors: {} };
  errorMessage = 'There is a problem connecting to GRS Storefront. Please try again or contact support.';
  userPoints;
  pointsUrl;
  userProfile;
  months = CONSTANTS.months;

  constructor(
    private sellerService: SellerService,
    private popupMessageService: PopupMessageService,
    private router: Router,
    private route: ActivatedRoute,
    private managerService: ManagerService,
    private storeService: StoreService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    this.getPointsAvailable();
  }

  // Call when a user log out
  logoutUser() {
    this.storeService.unsubscribeRoute.next(true);
    this.storeService.changeProfileImage('');
    LocalService.flush('token');
    LocalService.flush('userProfile');
    LocalService.flush('selectedLanguage');
    LocalService.flush('selectedFile');
    this.userService.logout().subscribe((data) => {
    }, err => {
      this.errors = err;
    });
    this.router.navigate(['/']);
  }

  // Get the number of available points
  getPointsAvailable() {
    this.sellerService.getPointsAvailable().subscribe(data => {
      this.userPoints = data;
    }, err => {
      this.errors = err;
    });
  }

  // Get the url for points redemption
  getPointsGrsUrlForUser() {
    this.sellerService.getPointsGrsUrlForUser().subscribe(data => {
      this.pointsUrl = data;
      window.open(this.pointsUrl.url, '_blank');
    }, err => {
      this.errors = err;
      if (err.status && err.status === '500 - INTERNAL_SERVER_ERROR') {
        this.popupMessageService.showError(this.errorMessage, 'error');
      }
    });
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  // Split the data and return value
  splitData(value) {
    if (value) {
      const parseValue = parseFloat(value);
      const newData = parseValue.toLocaleString();
      return newData.toString();
    }
    return value;
  }

  // To convert the date format
  formatDate(date) {
    const formatDate = new Date(date.split('T')[0]);
    return `${this.months[formatDate.getMonth()]} ${formatDate.getDate()}, ${formatDate.getFullYear()}`;
  }

}
